import { Component, Input } from '@angular/core';
import { AuthAccountDetailsComponent } from "../auth-account-details/auth-account-details.component";
import {RouterLink} from "@angular/router";
import {NgIf} from "@angular/common";
import {UptimeViewComponent} from "../../../core/uptime-view/uptime-view.component";


@Component({
  selector: 'auth-user-account-info',
  templateUrl: './auth-account-info.component.html',
  imports: [
    RouterLink,
    NgIf,
    UptimeViewComponent
  ],
  standalone: true
})
export class AuthAccountInfoComponent extends AuthAccountDetailsComponent {
  @Input() accountDetailsRouterLink = '/account'
}

